<template>
  <div>
    <!-- Section header -->
    <div class="mb-6">
      <div class="ext-section-number">Attribution</div>
      <h1 class="ext-section-title" v-if="activeView === 'cost'">Cost Attribution</h1>
      <h1 class="ext-section-title" v-else-if="activeView === 'prospects'">Attribution Prospects</h1>
      <h1 class="ext-section-title" v-else>Patient Attribution</h1>
      <p class="ext-section-desc" v-if="activeView === 'cost'">
        Decomposes quarterly cost changes into component causes — leavers, stayers, and joiners — attributed to specific practices and care categories. Identifies whether cost shifts are driven by panel mix changes or per-patient spending drift.
      </p>
      <p class="ext-section-desc" v-else-if="activeView === 'prospects'">
        Patients seen at this entity's providers during the current performance year who are not currently attributed. Includes visit history, cost breakdown, and prior attribution status to identify panel growth opportunities.
      </p>
      <p class="ext-section-desc" v-else-if="activeView === 'flow'">
        Tracks how patients move between attribution reports — retained, newly attributed, lost to competition, deceased, or disengaged. Compare any two report dates to understand panel changes.
      </p>
      <p class="ext-section-desc" v-else>
        Current patient attribution roster with demographics, cost, risk, and visit history. Tracks panel composition across report dates and identifies retained, new, and lost patients between attribution periods.
      </p>
    </div>

    <div style="display:flex; gap:10px; align-items:center; margin-bottom:16px;">
      <span style="font-size:12px; color:#6B7280;">Care Setting:</span>
      <select v-model="careSetting"
        style="padding:5px 10px; border:1px solid #D1D5DB; border-radius:6px; font-size:13px; color:#374151; background:#fff;">
        <option value="">All</option>
        <option value="SNF">SNF</option>
        <option value="ALF">ALF</option>
      </select>
    </div>
    <div v-if="!entityId" style="padding: 40px; text-align: center; color: #A9A29A; font-size: 13px;">
      Select a practice to view attribution.
    </div>
    <template v-else>
      <CostAttributionFlow
        v-if="activeView === 'cost'"
        :entity-id="entityId"
      />
      <AttributionPatientReport
        v-else-if="activeView === 'patient_report'"
        :entity-id="entityId"
        :care-setting="careSetting"
      />
      <AttributionProspects
        v-else-if="activeView === 'prospects'"
        :entity-id="entityId"
        :care-setting="careSetting"
      />
      <AttributionHealth
        v-else-if="activeView === 'flow'"
        :entity-id="entityId"
      />
    </template>
  </div>
</template>

<script>
import CostAttributionFlow from '@/components/InsightsNew/CostAttributionFlow.vue';
import AttributionPatientReport from './AttributionPatientReport.vue';
import AttributionProspects from './AttributionProspects.vue';
import AttributionHealth from '@/components/Entity/Attribution_Health.vue';

export default {
  name: 'ExternalAttribution',
  components: { CostAttributionFlow, AttributionPatientReport, AttributionProspects, AttributionHealth },
  props: {
    entityId: { type: Number, default: null },
    activeView: { type: String, default: 'patient_report' },
  },
  data() {
    return { careSetting: '' };
  },
};
</script>
